import { render, staticRenderFns } from "./CaregiverCreate.vue?vue&type=template&id=5af7ab1e&scoped=true"
import script from "./CaregiverCreate.vue?vue&type=script&lang=js"
export * from "./CaregiverCreate.vue?vue&type=script&lang=js"
import style0 from "./CaregiverCreate.vue?vue&type=style&index=0&id=5af7ab1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7ab1e",
  null
  
)

export default component.exports